export type NormalizedExperimentStatus =
  | "concept"
  | "in_review"
  | "live"
  | "paused"
  | "completed"
  | "deleted"
  | "unknown";

const normalizeStatusToken = (value: string) =>
  value
    .trim()
    .toLowerCase()
    .replace(/[\s-]+/g, "_");

export const normalizeExperimentStatus = (
  status?: string | number | null,
): NormalizedExperimentStatus => {
  if (typeof status === "number") {
    switch (status) {
      case 1:
        return "concept";
      case 2:
        return "in_review";
      case 3:
        return "live";
      case 4:
        return "paused";
      case 5:
        return "completed";
      case 6:
        return "deleted";
      default:
        return "unknown";
    }
  }

  const normalized = normalizeStatusToken(String(status ?? ""));

  switch (normalized) {
    case "concept":
    case "draft":
      return "concept";
    case "in_review":
    case "review":
    case "locked":
      return "in_review";
    case "live":
    case "running":
    case "started":
      return "live";
    case "paused":
    case "pause":
      return "paused";
    case "completed":
    case "complete":
    case "ended":
    case "finished":
    case "done":
      return "completed";
    case "archived":
    case "deleted":
    case "removed":
      return "deleted";
    default:
      return "unknown";
  }
};

export const isExperimentLockedStatus = (status?: string | number | null) => {
  const normalizedStatus = normalizeExperimentStatus(status);

  return (
    normalizedStatus === "live" ||
    normalizedStatus === "paused" ||
    normalizedStatus === "completed" ||
    normalizedStatus === "deleted"
  );
};

export const formatExperimentStatusLabel = (
  status?: string | number | null,
) => {
  switch (normalizeExperimentStatus(status)) {
    case "concept":
      return "Concept";
    case "in_review":
      return "In Review";
    case "live":
      return "Live";
    case "paused":
      return "Paused";
    case "completed":
      return "Completed";
    case "deleted":
      return "Deleted";
    default:
      return "Unknown";
  }
};
